// Module
var code = "<div id=\"{{id}}\" class=\"form-group {{class}}\"> <label class=\"label\"><span data-i18n=\"{{label}}\">{{labelText}}</span><sup class=\"require\">*</sup></label> <select tabindex=\"{{tabIndex}}\" class=\"select-item\" required> <option></option> </select> <div data-i18n=\"{{invalid}}\" class=\"invalid-feedback\"></div> </div>";
// Exports
module.exports = code;